/* Path: assets/build-case-bundle.js
   Connects Section 2 (flavor cards) + Section 3 (tiers + order summary).
   Uses Shopify's built-in AJAX Cart API (/cart/add.js) — no app, no external key needed.
*/
(function () {
  'use strict';

  var BOTTLES_PER_CASE = 6;

  function buildPricingTable() {
    var table = {};
    document.querySelectorAll('.case-tier').forEach(function (el) {
      var cases = parseInt(el.getAttribute('data-cases'), 10);
      var price = parseFloat(el.getAttribute('data-price'));
      if (!isNaN(cases) && !isNaN(price)) table[cases] = price;
    });
    return table;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cards = document.querySelectorAll('.case-flavor-card');
    var addBtn = document.getElementById('case-add-to-cart');
    var contactBtn = document.getElementById('case-contact-btn');
    var listEl = document.getElementById('case-order-list');
    var caseLabelEl = document.getElementById('case-order-case-label');
    var subtotalEl = document.getElementById('case-order-subtotal');
    var totalEl = document.getElementById('case-order-total');
    var messageEl = document.getElementById('case-order-message');
    var tierCards = document.querySelectorAll('.case-tier');

    if (!cards.length || !addBtn) return;

    var pricingTable = buildPricingTable();

    // Contact button is no longer used — keep it hidden at all times
    if (contactBtn) contactBtn.style.display = 'none';

    function getQty(card) {
      return parseInt(card.querySelector('.case-flavor-card__qty').textContent, 10) || 0;
    }
    function setQty(card, val) {
      card.querySelector('.case-flavor-card__qty').textContent = val;
    }

    cards.forEach(function (card) {
      card.querySelector('.case-flavor-card__btn--minus').addEventListener('click', function () {
        var qty = getQty(card);
        if (qty > 0) { setQty(card, qty - 1); update(); }
      });
      card.querySelector('.case-flavor-card__btn--plus').addEventListener('click', function () {
        setQty(card, getQty(card) + 1);
        update();
      });
    });

    function update() {
      var totalBottles = 0;
      var selections = [];

      cards.forEach(function (card) {
        var qty = getQty(card);
        if (qty > 0) {
          totalBottles += qty;
          selections.push({
            variantId: card.getAttribute('data-variant-id'),
            title: card.getAttribute('data-product-title'),
            qty: qty
          });
        }
      });

      listEl.innerHTML = selections.length
        ? selections.map(function (s) {
            return '<li><span>' + s.title + '</span><span>' + s.qty + '</span></li>';
          }).join('')
        : '<li class="case-order-summary__empty">No flavors selected yet.</li>';

      var caseCount = Math.floor(totalBottles / BOTTLES_PER_CASE);
      var isExactMultiple = totalBottles > 0 && totalBottles % BOTTLES_PER_CASE === 0;

      if (totalBottles === 0) {
        caseLabelEl.textContent = '0 Bottles Selected';
      } else if (isExactMultiple) {
        caseLabelEl.textContent = caseCount + ' Case' + (caseCount === 1 ? '' : 's') +
          ' (' + totalBottles + ' Bottle' + (totalBottles === 1 ? '' : 's') + ')';
      } else {
        caseLabelEl.textContent = totalBottles + ' Bottle' + (totalBottles === 1 ? '' : 's') + ' Selected';
      }

      tierCards.forEach(function (t) {
        var tCases = parseInt(t.getAttribute('data-cases'), 10);
        t.classList.toggle('is-active', isExactMultiple && tCases === caseCount);
      });

      if (totalBottles === 0) {
        subtotalEl.textContent = '$0.00';
        totalEl.textContent = '$0.00';
        messageEl.textContent = '';
        addBtn.disabled = true;
        addBtn.style.display = '';
        return;
      }

      if (!isExactMultiple) {
        var needed = BOTTLES_PER_CASE - (totalBottles % BOTTLES_PER_CASE);
        messageEl.textContent = 'Add ' + needed + ' more bottle' + (needed === 1 ? '' : 's') + ' to complete a case (must be a multiple of 6).';
        addBtn.disabled = true;
        subtotalEl.textContent = '—';
        totalEl.textContent = '—';
        addBtn.style.display = '';
        return;
      }

      addBtn.style.display = '';
      addBtn.disabled = false;
      messageEl.textContent = '';

      var price = pricingTable[caseCount];
      if (price === undefined || isNaN(price)) {
        price = (pricingTable[1] || 0) * caseCount; // fallback if a tier wasn't configured
      }
      subtotalEl.textContent = '$' + price.toFixed(2);
      totalEl.textContent = '$' + price.toFixed(2);

      addBtn.setAttribute('data-selections', JSON.stringify(selections));
    }

    addBtn.addEventListener('click', function () {
      var selections = JSON.parse(addBtn.getAttribute('data-selections') || '[]');
      if (!selections.length) return;

      addBtn.disabled = true;
      var originalText = addBtn.textContent;
      addBtn.textContent = 'ADDING...';

      var items = selections.map(function (s) {
        return { id: s.variantId, quantity: s.qty };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error(err);
          messageEl.textContent = 'Something went wrong adding to cart. Please try again.';
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        });
    });

    update();
  });
})();